/**
 * LoadingView Component
 * 
 * Displays loading state with progress indicators
 */

import React from 'react';
import { COLORS, SHADOWS, BORDER_RADIUS, SPACING, FONT_SIZES } from '../data/constants';

const LoadingView = ({ message = 'Loading data...' }) => {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.spinnerContainer}>
          <div style={styles.spinner}></div>
        </div>
        <h2 style={styles.title}>{message}</h2>
        <div style={styles.stepsContainer}>
          <LoadingStep text="Fetching Polymarket market data" />
          <LoadingStep text="Fetching YouTube video information" />
          <LoadingStep text="Analyzing trades and market movements" />
        </div>
      </div>
    </div>
  );
};

const LoadingStep = ({ text }) => {
  return (
    <div style={styles.step}>
      <div style={styles.stepDot}></div>
      <span style={styles.stepText}>{text}</span>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: COLORS.PRIMARY_DARK,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: SPACING.LG,
  },
  card: {
    backgroundColor: COLORS.WHITE,
    borderRadius: BORDER_RADIUS.LARGE,
    boxShadow: SHADOWS.RADIAL_LARGE,
    maxWidth: '500px',
    width: '100%',
    padding: SPACING.XXL,
    textAlign: 'center',
  },
  spinnerContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: SPACING.XL,
  },
  spinner: {
    width: '60px',
    height: '60px',
    border: `4px solid ${COLORS.LIGHT_GRAY}`,
    borderTop: `4px solid ${COLORS.PRIMARY_BLUE}`,
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  title: {
    fontSize: FONT_SIZES.XL,
    fontWeight: '600',
    color: COLORS.PRIMARY_DARK,
    marginBottom: SPACING.XL,
  },
  stepsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: SPACING.MD,
    alignItems: 'flex-start',
  },
  step: {
    display: 'flex',
    alignItems: 'center',
    gap: SPACING.MD,
  },
  stepDot: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    backgroundColor: COLORS.PRIMARY_BLUE,
    flexShrink: 0,
    animation: 'pulse 2s ease-in-out infinite',
  },
  stepText: {
    fontSize: FONT_SIZES.SM,
    color: COLORS.GRAY,
    textAlign: 'left',
  },
};

// Add CSS animations
const styleSheet = document.createElement("style");
styleSheet.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  @keyframes pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.5; transform: scale(0.8); }
  }
`;
document.head.appendChild(styleSheet);

export default LoadingView;

